import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { Button } from '../Button';
import { ScrollableContainer } from '../ScrollableContainer';
import { AbstractPopup, DismissalReason, } from './AbstractPopup';
export function FormPopup({ children, reject, onSubmit, canSubmit, cancelButtonProps, okButtonProps, title, ...props }) {
    return (_jsx(FormPopupRoot, { reject: reject, ...props, children: _jsxs(Form, { onSubmit: (e) => {
                e.preventDefault();
                if (canSubmit) {
                    onSubmit?.();
                }
            }, children: [_jsxs(Header, { children: [_jsx(CloseButton, { type: "button", onClick: () => {
                                reject(DismissalReason.CloseButton);
                            }, children: _jsxs("svg", { width: "15", height: "16", viewBox: "0 0 15 16", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("title", { children: "Close button" }), _jsx("path", { d: "M0.285645 14.7896C0.156738 14.6665 0.0717773 14.52 0.0307617 14.3501C-0.0102539 14.1802 -0.0102539 14.0103 0.0307617 13.8403C0.0776367 13.6704 0.162598 13.5269 0.285645 13.4097L5.68213 7.99561L0.285645 2.59033C0.162598 2.47314 0.0805664 2.32959 0.0395508 2.15967C-0.00146484 1.98975 -0.00146484 1.81982 0.0395508 1.6499C0.0805664 1.47998 0.162598 1.3335 0.285645 1.21045C0.414551 1.08154 0.563965 0.996582 0.733887 0.955566C0.903809 0.914551 1.07373 0.914551 1.24365 0.955566C1.41357 0.996582 1.56006 1.07861 1.68311 1.20166L7.08838 6.60693L12.4849 1.20166C12.6079 1.07275 12.7544 0.990723 12.9243 0.955566C13.0942 0.914551 13.2612 0.914551 13.4253 0.955566C13.5952 0.996582 13.7476 1.08154 13.8823 1.21045C14.0054 1.3335 14.0874 1.47998 14.1284 1.6499C14.1753 1.81982 14.1753 1.98975 14.1284 2.15967C14.0874 2.32373 14.0054 2.47021 13.8823 2.59912L8.48584 7.99561L13.8823 13.4009C14.0054 13.5298 14.0874 13.6792 14.1284 13.8491C14.1694 14.0132 14.1694 14.1802 14.1284 14.3501C14.0874 14.52 14.0054 14.6665 13.8823 14.7896C13.7534 14.9185 13.604 15.0034 13.4341 15.0444C13.2642 15.0854 13.0942 15.0854 12.9243 15.0444C12.7544 15.0034 12.6079 14.9214 12.4849 14.7983L7.08838 9.39307L1.68311 14.7983C1.56006 14.9214 1.41357 15.0034 1.24365 15.0444C1.07959 15.0854 0.909668 15.0854 0.733887 15.0444C0.563965 15.0034 0.414551 14.9185 0.285645 14.7896Z", fill: "white" })] }) }), _jsxs(PopupTitle, { children: ["\u200C", title] }), _jsx("div", {})] }), _jsx(ScrollableContainer, { children: children }), (okButtonProps || cancelButtonProps) && (_jsxs(Buttons, { children: [cancelButtonProps && (_jsx(Button, { type: "button", size: "mini", kind: "secondary", padding: "small", onClick: cancelButtonProps.onClick, children: cancelButtonProps.label ?? 'Cancel' })), okButtonProps && (_jsxs(_Fragment, { children: [!cancelButtonProps && _jsx("div", {}), _jsx(Button, { type: "submit", size: "mini", kind: "secondary", padding: "small", onClick: okButtonProps.onClick, disabled: !canSubmit, children: okButtonProps.label ?? 'Ok' })] }))] }))] }) }));
}
const Buttons = styled.div `
    align-items: center;
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 1.25rem 1.5rem;
    gap: 1rem;
    border-top: 1px solid #dedede33;

    @media (min-width: 32.5rem) {
        display: flex;
        justify-content: flex-end;

        button {
            width: 6.5rem;
        }
    }
`;
const PopupTitle = styled.h2 `
    font-weight: 600;
    font-size: 1.375rem;
    line-height: 1.75rem;
    text-align: center;
`;
const CloseButton = styled.button `
    appearance: none;
    background: rgba(231, 231, 231, 0.2);
    padding: 0;
    border: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 2.75rem;
    height: 2.75rem;
    transition: 200ms background-color;

    &:hover {
        background: rgba(231, 231, 231, 0.3);
    }
`;
const Header = styled.div `
    display: grid;
    align-items: center;
    grid-template-columns: 2.75rem 1fr 2.75rem;
    padding: 1.5rem;
    gap: 1rem;
`;
const Form = styled.form `
    display: grid;
    grid-template-rows: auto 1fr auto;
    height: var(--vh-100, 100vh);

    @media (min-width: 22.5rem) {
        height: auto;
        max-height: min(40rem, calc(var(--vh-100, 100vh) - 2rem));
    }
`;
const FormPopupRoot = styled(AbstractPopup) `
    --Popup_X: 0;
    --Popup_Y: 0;

    --Popup_Width: var(--vw-100, 100vw);
    --Popup_MaxWidth: var(--vw-100, 100vw);
    --Popup_Padding: 0;

    --Popup_Border: 0;
    --Popup_BoxShadow: none;

    /* Offset transitions */
    --Popup_OffsetTransition: none;

    @media (min-width: 22.5rem) {
        --Popup_InitialScale: 0.98;
        --Popup_Left: 50%;
        --Popup_Top: 50%;
        --Popup_X: -50%;
        --Popup_Y: -50%;
        --Popup_InitialOffsetY: 1rem;
        --Popup_OffsetY: 0;
        --Popup_BorderRadius: 2rem;

        --Popup_Width: 28.625rem;
        --Popup_MaxWidth: calc(var(--vw-100, 100vw) - 2rem);
        --Popup_Border: initial;
        --Popup_BoxShadow: initial;

        /* Offset transitions */
        --Popup_OffsetTransition: initial;
    }
`;
